import types, { ActionCreators, CSVUploadAction, CSVUploadConfig } from './types';

const createCSVUploadERR: ActionCreators['CreateCSVUploadERR'] = (errorMessages, error) => ({
  type: types.CREATE_CSV_UPLOAD_ERROR,
  errorMessages,
  error,
});

const createCSVUploadOK: ActionCreators['CreateCSVUploadOK'] = (csvUpload) => ({
  type: types.CREATE_CSV_UPLOAD_OK,
  csvUpload,
});

const createCSVUpload: ActionCreators['CreateCSVUpload'] = (
  action: CSVUploadAction,
  config: CSVUploadConfig,
  file: File,
  chainId: string,
) => ({
  type: types.CREATE_CSV_UPLOAD,
  action,
  config,
  file,
  chainId,
});

const polledRequestCSVUpload: ActionCreators['PolledCSVUpload'] = (
  csvUploadId,
  refetchSegments,
  chainId,
) => ({
  type: types.POLLED_REQUEST_CSV_UPLOAD,
  csvUploadId,
  refetchSegments,
  chainId,
});

const polledRequestCSVUploads: ActionCreators['PolledCSVUploads'] = ({
  action = '',
  csvUploadIds = [],
  polled = false,
  chainId,
}) => ({
  type: types.POLLED_REQUEST_CSV_UPLOADS,
  action,
  csvUploadIds,
  polled,
  chainId,
});

const requestCSVUpload: ActionCreators['RequestCSVUpload'] = (csvUploadId, chainId) => ({
  type: types.REQUEST_CSV_UPLOAD,
  csvUploadId,
  chainId,
});

const requestCSVUploadERR: ActionCreators['RequestCSVUploadERR'] = (errorMessages, error) => ({
  type: types.REQUEST_CSV_UPLOAD_ERR,
  errorMessages,
  error,
});

const requestCSVUploadOK: ActionCreators['RequestCSVUploadOK'] = (csvUpload) => ({
  type: types.REQUEST_CSV_UPLOAD_OK,
  csvUpload,
});

const requestCSVUploads: ActionCreators['RequestCSVUploads'] = ({
  action = '',
  csvUploadIds = [],
  chainId,
}) => ({
  type: types.REQUEST_CSV_UPLOADS,
  action,
  csvUploadIds,
  chainId,
});

const requestCSVUploadsERR: ActionCreators['RequestCSVUploadsERR'] = (errorMessages, error) => ({
  type: types.REQUEST_CSV_UPLOADS_ERR,
  errorMessages,
  error,
});

const requestCSVUploadsOK: ActionCreators['RequestCSVUploadsOK'] = (csvUploads) => ({
  type: types.REQUEST_CSV_UPLOADS_OK,
  csvUploads,
});

const actions = {
  createCSVUploadERR,
  createCSVUploadOK,
  createCSVUpload,
  polledRequestCSVUpload,
  polledRequestCSVUploads,
  requestCSVUpload,
  requestCSVUploadERR,
  requestCSVUploadOK,
  requestCSVUploads,
  requestCSVUploadsERR,
  requestCSVUploadsOK,
};

export default actions;
